import { NgModule, isDevMode } from '@angular/core';
import { MaterialModule } from './material.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule } from '@angular/common/http'
import { AppComponent } from './app.component';
import { BoatsComponent } from './boats/boats.component';
import { DialogComponent } from './dialog/dialog.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

// 23/05/2023
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        AppComponent,
        BoatsComponent,
        DialogComponent
    ],
    imports: [
        MaterialModule,
        BrowserModule,
        BrowserAnimationsModule,
        DragDropModule,
        HttpClientModule,
        // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
        // MM Aggiungo su suggerimento forum la registrationStrategy, sembra che i Workers siano disponibili
        // ATTENZIONE, nell'edito viene segnalato errore "ServiceWorkerModule does not appear to be a NgModule class"
        // Non ho capito il motivo, i tentativ di compilazione con IvY esclusa falliscono.
        // ATTENZIONE ATTENZIONE per avere i ServiceWorker attivi serve compilare in modalità produzione
        
        // Registrazione vecchia su angular 8, funzionante
        // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production, registrationStrategy: "registerImmediately" }),
        
        // Nuovo aggiunto da installazione pwa angular 15, NON FUNZIONANTE
        // ServiceWorkerModule.register('ngsw-worker.js', {
        //   enabled: !isDevMode(),
        //   // Register the ServiceWorker as soon as the application is stable
        //   // or after 30 seconds (whichever comes first).
        //   registrationStrategy: 'registerWhenStable:30000'
        // })

        // Nuovo avvio con eliminato opzione di abilitazione in debug e ritardo all'avvio, sembra funzionare
        ServiceWorkerModule.register('ngsw-worker.js', {
          // Register the ServiceWorker immediately
          registrationStrategy: 'registerImmediately'
        })
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
